import router from './router'
import store from './store'
import settings from '@/settings'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken, getPermissions } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

router.beforeEach(async(to, from, next) => {
  console.log(to)
  console.log(from)

  // start progress bar
  NProgress.start()
  // set page title
  document.title = getPageTitle(to.meta.title)

  // 切换路由时清空上个路由未完成的所有请求
  // const CancelToken = axios.CancelToken
  // global.store.source.cancel && global.store.source.cancel()
  // global.store.source = CancelToken.source()
  window._axiosPromiseArr.forEach((ele,index) => {
    ele.cancel() // 路由跳转之前，清空（终止）上一个页面正在请求的内容
    delete window._axiosPromiseArr[index]
  })
  if(to.path!='/' && from.path!='/' && !to.query.t) {
    return next({
      path: to.path,
      query: Object.assign({}, to.query, {
        t: randomString(8)
      })
    })
  }
  
  next()
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})

function randomString(e) {    
  e = e || 32;
  var t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678",
  a = t.length,
  n = "";
  for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a));
  return n
}